import { Observable } from 'rxjs'
import CryptoJS from 'crypto-js'
import { Wallet, utils } from 'ethers'

import { logger } from '../util/helpers'
import storage from '../services/storage'

class WalletService {

  createWallet$() {
    return Observable.create(observer => {
      const wallet = Wallet.createRandom()
      observer.next(wallet.signingKey)
      observer.complete()
      return () => logger('unsubscribing from createWallet$')
    })
  }  

  restoreWallet$(mnemonic) {
    return Observable.create(observer => {
      const wallet = Wallet.fromMnemonic(mnemonic)
      observer.next(wallet)
      observer.complete()
      return () => logger('unsubscribing from restoreWallet$')
    })
  }


  unlockWallet$(encryptedWallet, password) {
    return Observable.create(observer => {
      try {
        const bytes  = CryptoJS.AES.decrypt(encryptedWallet, password)
        const wallet = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
        if (wallet.signingKey) {
          observer.next(wallet.signingKey)  
        } else {
          observer.next(wallet)
        }
        observer.complete()
      } catch (e) {
        observer.error('error-messages.mistyped-password')
      }
      return () => logger('unsubscribing from unlockWallet$')
    })
  }

  setNewPassword$(wallet, password) {
    return Observable.create(observer => {
      try {
        const encryptedWallet = storage.encryptAndStoreWallet(wallet, password)
        observer.next(encryptedWallet)
        observer.complete()
      } catch (e) {
        observer.error('error-messages.invalid-password')
      }
      return () => logger('unsubscribing from saveWallet$')
    })
  }

  _validateMnemonic(mnemonic) {
    return utils.HDNode.isValidMnemonic(mnemonic)
  }

}

const walletService = new WalletService()

export default walletService



// WEBPACK FOOTER //
// ./src/services/wallet.js